// extracted by mini-css-extract-plugin
export default {"copyright":"Gydqd","toggle":"GoKkM","text":"MWXiC","iconChevron":"MaC3X"};